import r,{domToReact as t}from"html-react-parser";export{Element}from"html-react-parser";import o from"isomorphic-dompurify";const e=(t,e)=>{const m=o.sanitize(t,{FORBID_TAGS:["script","style"]});return r(m,e)},m=r=>t(r);export{m as domToReact,e as parseHtml};
//# sourceMappingURL=parse-html.js.map
